import { render, staticRenderFns } from "./orgOwnerMain.vue?vue&type=template&id=5724ddab&%3Akey=componentKey&"
import script from "./orgOwnerMain.vue?vue&type=script&lang=js&"
export * from "./orgOwnerMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports